import React from "react";
import FaqHead from "../../HomePage/Faq/FaqHead";
import ApostilleFaqMain from "./ApostilleFaqMain";
import "./../../HomePage/Faq/Faq.css";

const ApostilleFaq = () => {
  return (
    <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="Apostille Services in Bangalore" />
        <ApostilleFaqMain />
      </div>
    </div>
  );
};

export default ApostilleFaq;
